import {
   HealthcareProviderNotificationConfiguration,
   HealthcareProviderWaitlistTimeSlotReservedPatientNotificationConfigurationQuery,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';

type PatientPhoneNotificationWaitlistProposedAppointmentToggleLoaderRenderProps = {
   notificationEnabled: boolean;
   messages: string[];
   refetch: VoidFunction;
};

type PatientPhoneNotificationWaitlistProposedAppointmentToggleLoaderProps = {
   readonly children: (
      renderProps: PatientPhoneNotificationWaitlistProposedAppointmentToggleLoaderRenderProps
   ) => JSX.Element;
};

export const PatientPhoneNotificationWaitlistProposedAppointmentToggleLoader = (
   props: PatientPhoneNotificationWaitlistProposedAppointmentToggleLoaderProps
): JSX.Element | null => {
   const {
      data: healthcareProviderNotificationConfiguration,
      loading: healthcareProviderNotificationConfigurationLoading,
      error: healthcareProviderNotificationConfigurationError,
      refetch,
   } = useCqrsGet<HealthcareProviderNotificationConfiguration>(() => {
      return new HealthcareProviderWaitlistTimeSlotReservedPatientNotificationConfigurationQuery();
   });

   if (
      healthcareProviderNotificationConfigurationLoading ||
      healthcareProviderNotificationConfigurationError ||
      !healthcareProviderNotificationConfiguration
   ) {
      return null;
   }

   return props.children({
      notificationEnabled: healthcareProviderNotificationConfiguration.enabled,
      messages: healthcareProviderNotificationConfiguration.messages,
      refetch: refetch,
   });
};
